export default "__VITE_ASSET__CIrke7d6__"